'use strict';

import _ from 'lodash';

export default function() {
  return {
    controller: function($scope, $http, $sce, $uibModal) {
      'ngInject';


      $scope.page = 1;
      $scope.show = 4;

      $scope.showLetter = function showLetter(letter) {
        $uibModal.open({
          templateUrl: 'LetterPopup',
          size: 'xlg',
          windowClass: 'LargePopup',
          controller: function($scope, $uibModalInstance) {
            $scope.letter = letter;
          }
        });
      };


      $scope.getCurrent = function getCurrent() {
        if($scope.letters) {
          return $scope.letters.slice(($scope.page - 1) * $scope.show, $scope.page * $scope.show);
        }
        return null;
      };

      $scope.Move = function Move(dir) {
        $scope.page += dir;
        var totalPages = Math.ceil($scope.letters.length / $scope.show);
        if($scope.page < 1) {
          $scope.page = totalPages
        } else if ($scope.page > totalPages) {
          $scope.page = 1;
        }
      }

      $http({
        url: '/api/testimonial/gettestimonials?filter=Letters',
        method: 'get'
      })
        .then(function Success(result) {
          $scope.letters = result.data;
        }, function Fail(result) {
          console.log("GetLetters Failed: " + result);
        })

    },
    template: require('./letters.html')
  };
};



// WEBPACK FOOTER //
// ./sgcontenteditor/customElements/letters.js